<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  withBorder: { type: Boolean, default: false },
  hideContent: { type: Boolean, default: false },
  beta: { type: Boolean, default: false },
});
const { t } = useI18n();
</script>

<template>
  <section
    class="grid grid-cols-1 pt-8 gap-6 [interpolate-size:allow-keywords]"
    :class="{
      'border-t border-border/50': withBorder,
      'pb-8': !hideContent,
    }"
  >
    <header class="grid grid-cols-4">
      <div
        v-if="
          title || beta || $slots.title || description || $slots.description
        "
        class="col-span-3"
      >
        <h4
          v-if="title || beta || $slots.title"
          class="text-xl font-bold tracking-tight text-foreground flex items-center gap-3"
        >
          <slot name="title">{{ title }}</slot>
          <div
            v-if="beta"
            v-tooltip.top="t('GENERAL.BETA_DESCRIPTION')"
            class="text-[10px] font-bold uppercase tracking-widest text-primary border border-primary/20 bg-primary/10 rounded-full px-2 py-0.5"
          >
            {{ t('GENERAL.BETA') }}
          </div>
        </h4>
        <p
          v-if="description || $slots.description"
          class="text-sm font-medium leading-relaxed text-muted-foreground mt-2 max-w-2xl"
        >
          <slot name="description">{{ description }}</slot>
        </p>
      </div>
      <div class="col-span-1 flex justify-end">
        <slot name="headerActions" />
      </div>
    </header>
    <div
      class="transition-[height] duration-300 ease-in-out text-foreground"
      :class="{ 'overflow-hidden h-0': hideContent, 'h-auto': !hideContent }"
    >
      <div
        class="bg-background/50 border border-border/50 rounded-2xl p-6 shadow-sm"
      >
        <slot />
      </div>
    </div>
  </section>
</template>
